import type { SVGProps } from 'react';

import type { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}

/**
 * ### IconYoutube
 *
 * Draws the YouTube play mark using the current text color so it matches the
 * existing LinkedIn and Facebook header icons.
 *
 * @param props Icon size and SVG presentation attributes
 * @returns The YouTube icon
 */
export default function IconYoutube({ size = 24, ...props }: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21.58 7.19a2.98 2.98 0 0 0-2.1-2.11C17.63 4.56 12 4.56 12 4.56s-5.63 0-7.48.52a2.98 2.98 0 0 0-2.1 2.11A31 31 0 0 0 1.9 12a31 31 0 0 0 .52 4.81 2.98 2.98 0 0 0 2.1 2.11c1.85.52 7.48.52 7.48.52s5.63 0 7.48-.52a2.98 2.98 0 0 0 2.1-2.11A31 31 0 0 0 22.1 12a31 31 0 0 0-.52-4.81ZM10 15.5v-7l6 3.5-6 3.5Z" />
    </svg>
  );
}
